import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook, Problem, WhyItDidntWork, UniqueMechanism } from './components/ContentSections';
import { WhatYouGet, WhoItsFor } from './components/Features';
import { HowItWorks, Proof } from './components/ProcessAndProof';
import { FAQ, FinalCTA, Footer } from './components/FAQAndFooter';
import { GetResponseAnalytics } from './components/Shared';
export function App() {
  return <main className="min-h-screen bg-cream overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyItDidntWork data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoItsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <GetResponseAnalytics data-id="element-13" />
    </main>;
}